import React, { memo } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

interface DeleteConfirmDialogProps {
  open: boolean;
  title: string;
  onCancel: () => void;
  onConfirm: () => void;
  children: React.ReactNode;
  cancelText?: string;
  confirmText?: string;
  maxWidth?: 'xs' | 'sm';
  /** When true (default), Cancel is contained and Confirm is outlined error.
   *  When false, Cancel is outlined and Confirm is contained error. */
  destructive?: boolean;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  title,
  onCancel,
  onConfirm,
  children,
  cancelText = 'Cancel',
  confirmText = 'Delete',
  maxWidth = 'sm',
  destructive = true,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth={maxWidth} fullWidth>
    <DialogTitle>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <DeleteIcon color="error" />
        <Typography variant="h6">{title}</Typography>
      </Box>
    </DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions sx={{ px: 3, py: 2 }}>
      <Button onClick={onCancel} variant={destructive ? 'contained' : 'outlined'}>
        {cancelText}
      </Button>
      <Button
        onClick={onConfirm}
        variant={destructive ? 'outlined' : 'contained'}
        color="error"
        startIcon={destructive ? <DeleteIcon /> : undefined}
        autoFocus={!destructive}
      >
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
);

export default memo(DeleteConfirmDialog);
